import React from "react";
import ImageSequence from "./ImageSequence";

const Image = ({ data, images }) => {
  if (images.sequence) {
    return <ImageSequence images={images.sequenceSources} />;
  }

  return (
    <img
      className="app-image active"
      alt={images.imageAltText}
      src={require(`../images/${images.name}`)}
    />
  );
};

export default Image;
